import { Description, TextInput } from "ui";
import { z } from "zod";
import { BlockEditorForm } from "../../BlockEditorForm";

const VideoBlockSchema = z.object({
  videoUrl: z.string().url("Must be a valid URL").min(1, "Video URL is required"),
});

type VideoBlockData = z.infer<typeof VideoBlockSchema>;

interface Props {
  videoUrl: string;
  onChangeUrl: (url: string) => void;
  onClose: () => void;
}

export function Editor({ videoUrl, onChangeUrl, onClose }: Props) {
  const defaultValues: VideoBlockData = {
    videoUrl,
  };

  const handleSubmit = async (data: VideoBlockData) => {
    onChangeUrl(data.videoUrl);
  };

  return (
    <BlockEditorForm schema={VideoBlockSchema} defaultValues={defaultValues} onSubmit={handleSubmit} onClose={onClose}>
      <TextInput name="videoUrl" label="Video URL" placeholder="https://www.youtube.com/watch?v=..." />
      <Description>Supports YouTube, Vimeo, and other popular video platforms</Description>
    </BlockEditorForm>
  );
}
